import { PropType, ExtractPropTypes } from 'vue'
import { Required } from 'utility-types'
import { SelectProps } from 'ant-design-vue/es/select'

export const miniappApiSelectProps = {
  apiParams: {
    type: Object,
    default: () => ({})
  }
}

export type MiniappApiSelect = Partial<ExtractPropTypes<typeof miniappApiSelectProps>> & SelectProps